import { useState, useEffect } from 'react';
import { ColumnPeriodT } from 'helpers/types';
import { getDefaultColumnPeriods, getLastStatisticPeriods, updateLastStatisticPeriods } from 'helpers';

interface UseColumnPeriodsProps {
  initialPeriods?: ColumnPeriodT[];
  dateRange: [string | null, string | null];
}

export const useColumnPeriods = ({ initialPeriods, dateRange }: UseColumnPeriodsProps) => {
  const [columnPeriods, setColumnPeriods] = useState<ColumnPeriodT[]>(
    initialPeriods?.length ? initialPeriods : getLastStatisticPeriods()
  );

  useEffect(() => {
    updateLastStatisticPeriods(columnPeriods);
  }, [columnPeriods]);

  const addColumn = (name: string, period: [string, string]) => {
    const trimmed = name.trim();
    if (trimmed && !columnPeriods.some(col => col.name === trimmed)) {
      setColumnPeriods(prev => [...prev, { name: trimmed, period }]);
    }
  };

  const removeColumn = (colName: string) => {
    setColumnPeriods(prev => prev.filter(c => c.name !== colName));
  };

  const resetColumns = () => {
    setColumnPeriods(getDefaultColumnPeriods());
  };

  return {
    columnPeriods,
    setColumnPeriods,
    addColumn,
    removeColumn,
    resetColumns
  };
};
